export default __webpack_public_path__ + "static/media/cowrie.14dc79da.jpg";